
// Collection slider tab
// --------------------------------------------
function changeTab(){
  const allTabs = document.querySelectorAll('.js-tab');

  allTabs.forEach(tab => {
    const buttons = tab.querySelectorAll('.js-tab-button');
    const panels = tab.querySelectorAll('.js-tab-panel');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const target = button.dataset.target;
        panels.forEach(panel => {
          panel.classList.remove('active');
          if(panel.getAttribute('id') === target){
            panel.classList.add('active');
          }
        });
        buttons.forEach(btn => {
          btn.classList.remove('active');
          if(btn === button){
            btn.classList.add('active');
          }
        });
      });
    });
  });
}

window.addEventListener('DOMContentLoaded',()=>{
  changeTab();

});

document.addEventListener("DOMContentLoaded", function() {
  const images = document.querySelectorAll(".rimage-wrapper");

  const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5
  };

  const observer = new IntersectionObserver(function(entries, observer) {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target.querySelector('img');
            let src = img.dataset.src;
            if(src){
              src = src.replace('{width}', '540');
              img.src = src;
            }
            entry.target.classList.remove('lazyload--placeholder');
            if(img){
              img.classList.add('lazyloaded');
            }
              observer.unobserve(entry.target);
          }
      });
  }, options);

  images.forEach(image => {
      observer.observe(image);
  });
});
